import { render, staticRenderFns } from "./homeLayout.vue?vue&type=template&id=5b5585cd&scoped=true"
import script from "./homeLayout.vue?vue&type=script&lang=js"
export * from "./homeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5585cd",
  null
  
)

export default component.exports